module.exports = __webpack_public_path__ + "static/a.954026f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./res/TopGallery/a.jpg
// module id = 289
// module chunks = 114276838955818